    <div class="nav flex-column  navbar-custom"  role="tablist" aria-orientation="vertical">
      <!--
      <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Home</a>
      -->
        <div class="row" style="height: 5%;">

        </div>
        <div class="row row-custom">
          <ngx-avatar  size="50"  [src]="'https://avatarfiles.alphacoders.com/221/221262.jpg'"></ngx-avatar>
        </div>

        <!-- <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg"  routerLink="/consultaCliente">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/activity.png" alt="Si"/>
          </button>
        </div>

        <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg"  routerLink="/abflist">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/teams.png" alt="Si"/>
          </button>
        </div> -->
        <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/gestiones">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/calendar.png" alt="Si"/>
          </button>
        </div>
        <!-- <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/messaging.png" alt="Si"/>
          </button>
        </div> -->
        <!-- <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/abfgps">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/tasks.png" alt="Si"/>
          </button>
        </div>
        <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/AdminUserComponent">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/settings.png" alt="Si"/>
          </button>
        </div> -->
        <!-- <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/files.png" alt="Si"/>
          </button>
        </div> -->
        <!-- <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/notes.png" alt="Si"/>
          </button>
        </div> -->
        <!-- <div class="row row-custom">
          <button   type="button" class="btn btn-link btn-lg" routerLink="/abflist">
            <img class="rounded mx-auto d-block navicon" src="assets/images/navbar/activity.png" alt="Si"/>
          </button>
        </div> -->
        <div class="row" style="height: 5%;">

        </div>
    </div>

